import { createContext, useContext } from 'react'

import type { TeddyKey } from '@hazel/shared'

export interface SessionUser {
  id: string
  username: string
  displayName: string
  role: 'parent' | 'child'
  avatarKey: TeddyKey | null
}

export type SessionStatus = 'loading' | 'authenticated' | 'anonymous'

export interface Session {
  status: SessionStatus
  user: SessionUser | null
  refresh: () => Promise<void>
}

/**
 * Kept apart from the provider component so this module exports no components.
 * Mixing the two breaks Vite's fast refresh, which silently makes every edit a
 * full reload.
 */
export const SessionContext = createContext<Session | null>(null)

export function useSession(): Session {
  const session = useContext(SessionContext)
  if (!session) throw new Error('useSession must be used inside a SessionProvider')
  return session
}
